import { render, staticRenderFns } from "./CadNovoPosto.vue?vue&type=template&id=757ad574&"
import script from "./CadNovoPosto.vue?vue&type=script&lang=js&"
export * from "./CadNovoPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports